import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { getText } from '../../internal/TextLabels'

const CreditPlan = ({ months, costAlternatives, monthlyCost }) => {
  return (
    <React.Fragment>
      {months && (
        <div style={{ padding: '2rem 0.5rem 0 0' }}>
          {costAlternatives.length > 1 && (
            <b>{`${getText('payApply.priceSignageCost.choosePaymentPlan')} (${
              costAlternatives[costAlternatives.length - 1].months
            }-${costAlternatives[0].months} ${getText(
              'default.nonAbbrivations.months',
            )})`}</b>
          )}
          <h5>
            <NumberFormat
              value={monthlyCost || 0}
              displayType="text"
              thousandSeparator=" "
              renderText={val => getText('default.currency', val)}
            />
            {` / ${months} ${getText(
              'default.nonAbbrivations.months',
            )}`}
          </h5>
        </div>
      )}
    </React.Fragment>
  )
}

CreditPlan.propTypes = {
  costAlternatives: PropTypes.array.isRequired,
  months: PropTypes.number,
  monthlyCost: PropTypes.number,
}

CreditPlan.defaultProps = {
  creditCost: 0,
  monthlyCost: 0,
}

export default CreditPlan
